<template>
    <div>
        <house-filter :advfilter="advfilter" @refetch-data="SearchAdvanced" @clear-search="clearAdvanceSearch" />

        <b-card no-body>
            <div class="m-2">
                <div class="d-none d-md-block mb-2">
                    <b-row class="align-items-center">
                        <b-col cols="1" class="pr-0">
                            <b-form-checkbox
                                v-model="expire_c"
                                value="3"
                                class="custom-control-primary"
                            >
                                Exp
                            </b-form-checkbox>
                        </b-col>

                        <b-col cols="2" class="px-1">
                            <v-select
                                v-model="propertyStatusFilter"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :options="property_status"
                                label="name"
                                placeholder="Status"
                                class="w-100"
                            />
                        </b-col>

                        <b-col cols="2" class="pl-1">
                            <v-select
                                v-model="statusFilter"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                :options="actions_a"
                                label="name"
                                class="w-100"
                                placeholder="Action"
                            />
                        </b-col>
                    </b-row>
                </div>

                <b-table
                    ref="refPropertyListTable"
                    :items="houseListData"
                    responsive
                    striped
                    :fields="tableColumns"
                    :sort-by.sync="sortBy"
                    show-empty
                    bordered
                    empty-text="No matching records found"
                    class="position-relative"
                >
                    <template slot="top-row" slot-scope="{ fields }">
                        <th v-for="field in fields" :key="'fd'+field.key">
                            <b-form-input v-if="field.key == 'code'" v-model="houseCodeFilter" :placeholder="field.label" />
                            <div v-if="field.key == 'owner'">
                                <b-form-input
                                    v-model="ownerFilter"
                                    @input="onInputOwner"
                                    @keydown.down.prevent="moveDownOwner"
                                    @keydown.up.prevent="moveUpOwner"
                                    @keydown.enter.prevent="selectOwner(activeIndexOwner)"
                                    placeholder="Owner"
                                    autocomplete="off"
                                />
                                <ul
                                    v-if="showOwnerSuggestions && filteredOwner.length"
                                    class="list-group position-absolute zindex-dropdown"
                                    style="max-height: 200px; overflow-y: auto; width: 17%;"
                                >
                                    <li
                                        v-for="(item, index) in filteredOwner"
                                        :key="`${item.id}-${index}`"
                                        class="list-group-item list-group-item-action"
                                        :class="{ active: index === activeIndexOwner }"
                                        @click="selectOwner(index)"
                                    >
                                        {{ `${item.firstname} ${item.lastname}` }}
                                    </li>
                                </ul>
                            </div>
                            <b-form-input v-if="field.key == 'units'" v-model="unitFilter" :placeholder="field.label" />
                            <b-form-input v-if="field.key == 'floors'" v-model="floorFilter" :placeholder="field.label" />
                            <b-form-input v-if="field.key == 'bedroom'" v-model="bedroomFilter" :placeholder="field.label" />
                        </th>
                    </template>

                    <template #cell(image)="data">
                        <b-link variant="flat-primary" class="pb0" :to="{ name: 'house-upload', params: { id: data.item.id } }">
                            <b-badge variant="flat-primary" class="pb0">
                                <b-img
                                    class="img_house"
                                    :src="data.item.cover_image || 'https://findbangkokroom.com/public/img/storage/1698858264911-picture.png'"
                                    fluid
                                />
                            </b-badge>
                        </b-link>
                    </template>

                    <template #cell(code)="data">
                        <router-link
                            :to="{ name: 'house-edit', params: { id: data.item.id } }"
                            :class="{ 'text-red': data.item.is_active === 0 }"
                        >
                            {{ data.item.code }}
                        </router-link>
                        <b-badge
                            v-if="getActionById(data.item.action_id)"
                            :variant="getActionVariant(data.item.action_id)"
                        >
                            {{ getActionById(data.item.action_id).name }}
                        </b-badge>
                        <b-badge
                            v-if="getStatusById(data.item.status_id)"
                            :variant="getStatusVariant(data.item.status_id)"
                        >
                            {{ getStatusById(data.item.status_id).name }}
                        </b-badge>
                        <br />
                        {{ data.item.name[currentLocale] || data.item.house_pin.name[currentLocale] || '' }}
                    </template>

                    <template #cell(owner)="data">
                        {{ data.item.owner.firstname || '' }} {{ data.item.owner.lastname || '' }}
                    </template>

                    <template #cell(units)="data">
                        {{ data.item.house_no }}
                    </template>

                    <template #cell(floors)="data">
                        {{ data.item.floor }}
                    </template>

                    <template #cell(actions)="data">
                        <span>
                            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                                <template v-slot:button-content>
                                    <feather-icon
                                        icon="MoreVerticalIcon"
                                        size="16"
                                        class="text-body align-middle mr-25"
                                    />
                                </template>
                                <b-dropdown-item :to="{ name: 'house-edit', params: { id: data.item.id } }">
                                    <feather-icon icon="Edit2Icon" class="mr-50" />
                                    <span>Edit</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="deleteconfirm(data.item.id)">
                                    <feather-icon icon="TrashIcon" class="mr-50" />
                                    <span>Delete</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </span>
                    </template>
                </b-table>

                <div class="m-2 d-flex justify-content-between align-items-center">
                    <div>
                        <span>
                            Showing {{ (currentPage - 1) * perPage + 1 }}
                            –
                            {{ Math.min(currentPage * perPage, totalRows) }}
                            of {{ totalRows }} entries
                        </span>
                    </div>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="right"
                        size="md"
                        class="mb-0"
                    />
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormCheckbox, BTable, BFormInput, BBadge, BImg, BDropdown, BDropdownItem,
    BPagination, BLink,
} from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'
import HouseFilter from '../house-list/HouseFilter.vue'

export default {
    components: {
        BCard, BRow, BCol, BFormCheckbox, BTable, BFormInput, BBadge, BImg, BDropdown, BDropdownItem,
        BPagination, BLink, vSelect, HouseFilter,
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
    },
    data() {
        return {
            statusOptions: [
                { id: 1, name: 'Avl' },
                { id: 2, name: 'Rented' },
                { id: 3, name: 'Sale with tenant' },
                { id: 5, name: 'Own Stay' },
                { id: 6, name: 'Not Sure' },
                { id: 7, name: 'Cannot contact' },
                { id: 8, name: 'Follow up' },
                { id: 4, name: 'Sold' }
            ],
            tableColumns: [
                { key: 'image', label: 'Image', sortable: false, tdClass: 'tb-image' },
                {
                    key: 'code',
                    label: 'House Pin Code',
                    sortable: false,
                    filterOptions: { enabled: true, placeholder: 'Search Name' },
                },
                { key: 'owner', label: 'Owner', sortable: false },
                { key: 'units', label: 'Unit No.', sortable: true },
                { key: 'floors', label: 'Floor', sortable: true },
                { key: 'bedroom', label: 'Bedroom', sortable: true },
                { key: 'useable_area', label: 'Useable A.(sqm)', sortable: true },
                { key: 'land_area', label: 'Land A.(sqw)', sortable: true },
                { key: 'rent_price', label: 'Rent', sortable: true },
                { key: 'sale_price', label: 'Sale', sortable: true },
                { key: 'actions' },
            ],
            perPage: 10,
            currentPage: 1,
            totalRows: 0,
            expire_c: null,
            houseListData: [],
            sortBy: 'id',
            houseCodeFilter: '',
            ownerFilter: null,
            unitFilter: '',
            floorFilter: '',
            bedroomFilter: null,
            actionOptions: [],
            propertyStatusFilter: null,
            property_status: [],
            statusFilter: null,
            actions_a: [],
            advfilter: null,
            showOwnerSuggestions: false,
            activeIndexOwner: -1,
            filteredOwner: [],
            selectedOwnerId: null,
        }
    },
    created() {
        this.fetchHouseListData()
        this.fetchActionData()
        this.getStatus()
    },
    watch: {
        currentPage() {
            this.fetchHouseListData()
        },
        unitFilter() {
            this.fetchHouseListData()
        },
        houseCodeFilter() {
            this.fetchHouseListData()
        },
        floorFilter() {
            this.fetchHouseListData()
        },
        selectedOwnerId() {
            this.fetchHouseListData()
        },
    },
    methods: {
        async fetchHouseListData() {
            const q = this.$route.query
            try {
                const body = {
                    keyword: q.keyword || null,
                    action_id: this.statusFilter?.id || q.actionId || null,
                    status_id: this.propertyStatusFilter?.id || null,
                    bedroom: q.bedroom
                        ? q.bedroom.split(',').map(Number)
                        : (this.bedroomFilter ? this.bedroomFilter.split(',').map(Number) : null),
                    owner_id: q.ownerId || this.selectedOwnerId,
                    min_useable_area: q.minUseableArea || null,
                    max_useable_area: q.maxUseableArea || null,
                    min_land_area: q.minLandArea || null,
                    max_land_area: q.maxLandArea || null,
                    minPrice: q.minPrice || null,
                    maxPrice: q.maxPrice || null,
                    property_type: q.property_type || null,
                    bts_id: q.bts_id || null,
                    bts_ids: q.bts_ids || null,
                    mrt_id: q.mrt_id || null,
                    mrt_ids: q.mrt_ids || null,
                    arl_id: q.arl_id || null,
                    arl_ids: q.arl_ids || null,
                    zone_id: q.zone_id || null,
                    zones: q.zones || null,
                    amphure_id: q.amphure_id || null,
                    fac_id: q.fac_id || null,
                    amenity_id: q.amenity_id || null,
                    unit: q.unit || this.unitFilter || null,
                    floor: q.floor || this.floorFilter || null,
                    place_id: q.place_id || null,
                    expire_start: q.expire_start || null,
                    expire_end: q.expire_end || null,
                    avl_start: q.avl_start || null,
                    avl_end: q.avl_end || null,
                    order_by: 'id_asc',
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                }

                const { data } = await axios.post('v1/house/filter/list', body)
                this.houseListData = data.data
                this.totalRows = data.total || data.totalRows || 0
            } catch (err) {
                console.error('Error fetching house list:', err)
            }
        },
        async fetchActionData() {
            try {
                const { data } = await axios.get('property-action/v1/list')
                this.actionOptions = data.data
                this.actions_a = data.data
            } catch (error) {
                console.error('Error fetching actions:', error)
            }
        },
        async getStatus() {
            try {
                const { data } = await axios.post('/property/v1/status')
                this.property_status = data?.data || []
            } catch (error) {
                console.error('Error fetching status:', error)
            }
        },
        async deleteData(id) {
            // const confirmed = window.confirm('Are you sure you want to delete this house?')
            // if (!confirmed) return

            try {
                await axios.delete(`/v1/house/${id}`)
                this.fetchHouseListData()
            } catch (error) {
                console.error('Error deleting house:', error)
            }
        },
        getActionById(id) {
            return this.actionOptions.find(a => a.id === id)
        },
        getStatusById(id) {
            return this.statusOptions.find(a => a.id === id)
        },
        getStatusVariant(id) {
            const variantMap = { 1: 'light-success' }
            return variantMap[id] || 'light-secondary'
        },
        getActionVariant(id) {
            const variantMap = {
                1: 'light-secondary',
                2: 'light-info',
                3: 'light-success',
                4: 'light-warning',
            }
            return variantMap[id] || 'light-secondary'
        },
        SearchAdvanced() {
            this.currentPage = 1
            this.fetchHouseListData()
        },
        clearAdvanceSearch() {
            this.currentPage = 1
            this.fetchHouseListData()
        },
        async onInputOwner(value) {
            this.activeIndexOwner = -1

            if (!value || value.trim() === '') {
                this.filteredOwner = []
                this.showOwnerSuggestions = false
                this.selectedOwnerId = null
                return
            }

            this.showOwnerSuggestions = true
            try {
                const { data } = await axios.get(`/property/v1/owner/${value}`)
                this.filteredOwner = data?.data || []
            } catch {
                this.filteredOwner = []
            }
        },
        selectOwner(index) {
            const selected = this.filteredOwner[index]
            if (selected) {
                this.ownerFilter = `${selected.firstname} ${selected.lastname}`
                this.selectedOwnerId = selected.id
                this.showOwnerSuggestions = false
                this.filteredOwner = []
                this.activeIndexOwner = -1
            }
        },
        moveDownOwner() {
            if (this.activeIndexOwner < this.filteredOwner.length - 1) {
                this.activeIndexOwner++
            }
        },
        moveUpOwner() {
            if (this.activeIndexOwner > 0) {
                this.activeIndexOwner--
            }
        },
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm('Are you sure you want to delete this house?', {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                        this.deleteData(id)
                    }
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.zindex-dropdown {
  z-index: 1050;
}
.template-scroll-container::-webkit-scrollbar {
  height: 6px;
}
.template-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.text-red {
  color: red;
}
.img_house {
    width: 150px;
    height: 90px;
}
</style>
